import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import Toggle from 'components/ReusableComponents/Toggle'

import styles from '../EditTextDialog.module.scss'
import customLinkConstants from './constants'

const CampaignCustomUrl = ({
  isCustomLinkEnabled,
  handleChangeCustomLinkToggle,
  customLink,
  setCustomLink,
  isCustomLinkValid,
  category
}) => {
  const { toggleLabel, toggleHint } = customLinkConstants[category]
  return (
    <div className={styles.customReviewLinkHolder}>
      <Toggle
        label={toggleLabel}
        checked={isCustomLinkEnabled}
        handleChange={handleChangeCustomLinkToggle}
        className={styles.customReviewLinkToggle}
      />
      <p className={styles.customReviewLinkHint}>{toggleHint}</p>
      {isCustomLinkEnabled && (
        <div>
          <TextInput
            className={styles.customReviewLinkInput}
            label="Custom link"
            autoFocus
            value={customLink || ''}
            onChange={e => setCustomLink(e.target.value)}
            valid={isCustomLinkValid}
          />
          {customLink && !isCustomLinkValid && (
            <p className={styles.customRevieLinkError}>
              Enter a valid link starting with http or https
            </p>
          )}
        </div>
      )}
    </div>
  )
}

export default CampaignCustomUrl
